if (!customElements.get('custom-tabbed-products')) {
  customElements.define('custom-tabbed-products', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.tabs = [...this.querySelectorAll('[role=tab]')];
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault(); this.activate(next); this.tabs[next].focus();
        });
      });
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this);
      this.querySelectorAll('[role=tabpanel]').forEach(panel => {
        const track = panel.querySelector('.custom-tab-track');
        track.addEventListener('scroll', () => this.update(), {passive:true});
        for (const [selector, direction] of [['[data-prev]', -1], ['[data-next]', 1]]) {
          panel.querySelector(selector).addEventListener('click', () => {
            const positions = this.pagePositions(track);
            const current = this.pageIndex(track, positions);
            const next = Math.max(0, Math.min(positions.length - 1, current + direction));
            track.scrollTo({left: positions[next], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
          });
        }
      });
      this.update();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.ready = false; }
    activate(index) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1;
        this.querySelector(`[id="${tab.getAttribute('aria-controls')}"]`).hidden = i !== index;
      });
      this.update();
    }
    pagePositions(track) {
      const first = track.firstElementChild;
      if (!first || !track.clientWidth) return [0];
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const step = first.getBoundingClientRect().width + gap;
      if (step <= 0) return [0];
      const visible = Math.max(1, Math.round((track.clientWidth + gap) / step));
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      const positions = [0];
      for (let item = visible; item < track.children.length; item += visible) {
        const position = Math.min(item * step, max);
        if (position - positions[positions.length - 1] > 2) positions.push(position);
      }
      return positions;
    }
    pageIndex(track, positions) {
      return positions.reduce((nearest, position, index) =>
        Math.abs(position - track.scrollLeft) < Math.abs(positions[nearest] - track.scrollLeft) ? index : nearest, 0);
    }
    update() {
      const panel = this.querySelector('[role=tabpanel]:not([hidden])'); if (!panel) return;
      const track = panel.querySelector('.custom-tab-track');
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      const positions = this.pagePositions(track);
      const pages = positions.length;
      const current = this.pageIndex(track, positions) + 1;
      panel.querySelector('[data-position]').textContent = `${current} / ${pages}`;
      panel.querySelector('[data-prev]').disabled = track.scrollLeft < 2;
      panel.querySelector('[data-next]').disabled = track.scrollLeft >= max - 2;
    }
  });
}
